<div class="card-body-wrapper" id={{product.productId}}>
    <div class="card-body-wrapper__img">
      <img src={{product.image}} class="card-img-top" alt={{product.name}}>
    </div>
    <div class="card-details">
      <h3>{{product.name}} {{product.price}}</h3>
      <p>{{product.shortDescription}}</p>
    </div>
    <div class="product-card-action-wrapper">
      <div class="product-card-action-wrapper__inputs">
        <ng-content></ng-content>
      </div>
      <div>
        <a (click)="onDetailsClick(product.productId)" class="details-btn" name={{product.productId}}>{{showDetailsButtonCaption}}</a>
      </div>
  </div>
</div>